import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import dayjs from 'dayjs';

const LastTransactionOne = () => {
    const [macRequests, setMacRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMacRequests = async () => {
            try {
                setLoading(true);
                const data = await api.getMacRequests();
                setMacRequests(data.items || []);
            } catch (err) {
                console.error('Error fetching MAC requests:', err);
                setError('Failed to load MAC requests');
            } finally {
                setLoading(false);
            }
        };

        fetchMacRequests();
    }, []);

    const getStatusBadge = (status) => {
        const statusMap = {
            PENDING: { class: 'bg-warning-50 text-warning-700', text: 'Pending' },
            APPROVED: { class: 'bg-success-50 text-success-700', text: 'Approved' },
            REJECTED: { class: 'bg-danger-50 text-danger-700', text: 'Rejected' },
            COMPLETED: { class: 'bg-success-50 text-success-700', text: 'Completed' },
        };
        
        const statusInfo = statusMap[status] || { class: 'bg-gray-100 text-gray-800', text: status };
        return (
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusInfo.class}`}>
                {statusInfo.text}
            </span>
        );
    };

    return (
        <div className="col-xxl-6">
            <div className="card h-100">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
                    <h6 className="text-lg fw-semibold mb-0">Pending MAC Requests</h6>
                    <Link
                        to="/admin/mac-requests"
                        className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                    >
                        View All
                        <Icon icon="solar:alt-arrow-right-linear" className="icon" />
                    </Link>
                </div>
                <div className="card-body p-24">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : macRequests.length === 0 ? (
                        <div className="text-center py-4 text-muted">No pending MAC requests found</div>
                    ) : (
                        <div className="table-responsive scroll-sm">
                            <table className="table bordered-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">License ID</th>
                                        <th scope="col">MAC Address</th>
                                        <th scope="col">Requested</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {macRequests.map((request) => (
                                        <tr key={request.id}>
                                            <td>{request.license.license_key}</td>
                                            <td>{request.mac_address}</td>
                                            <td>{dayjs(request.requestedAt).format('DD MMM YYYY')}</td>
                                            <td>{getStatusBadge(request.status)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LastTransactionOne;